<template>
    <div>
        <SkeletonBase
            :content="2"
            has-divided
        />
        <SkeletonBase
            hasTitle
            :content="2"
            has-divided
        />
        <SkeletonBase
            hasTitle
            :content="4"
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
